import React from 'react'
import image1 from '../vendor/sort.jpg'
import image2 from '../vendor/travel.jpg'
import image3 from '../vendor/text analyze.jpg'
import image4 from '../vendor/covid.jpg'
import image5 from '../vendor/watches.jpg'
import image6 from '../vendor/cart.jpg'
import image7 from '../vendor/todo.jpg'
import image8 from '../vendor/amazon.jpg'
import image9 from '../vendor/weather.jpg'
import image10 from '../vendor/makeup.jpg'
import image11 from '../vendor/music.jpg'
import './Works.css';
import {
    Link
} from "react-router-dom";
import { useEffect } from 'react'

function Works() {

    useEffect(() => {
        document.title = "Harshita Singh — Design & Development"
    }, []);

    return (
        <div className="works">
            <div className="works__col">
                <div className="works__left">
                    <Link to="/sorting-visualizer">
                        <div class="works__container">
                            <img src={image1} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>Sorting Visualizer</h3>
                                    <p>Web development, data structures</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                    <Link to="/travel-image-gallery">
                        <div class="works__container">
                            <img src={image2} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>Travel Image Gallery</h3>
                                    <p>Web development, design</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                    <Link to="/text-analyzer">
                        <div class="works__container">
                            <img src={image3} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>Text Analyzer</h3>
                                    <p>Web development, design</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                    <Link to="/covid19-tracker">
                        <div class="works__container">
                            <img src={image4} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>Covid-19 Tracker</h3>
                                    <p>Web development, API</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>

                <div className="works__middle">
                    <Link to="/ecommerce-website">
                        <div class="works__container">
                            <img src={image5} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>E-commerce (Watches) website</h3>
                                    <p>Web development, design</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                    <Link to="/shopping-cart">
                        <div class="works__container">
                            <img src={image6} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>Shopping Cart</h3>
                                    <p>Web development, design</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                    <Link to="/to-do-list">
                        <div class="works__container">
                            <img src={image7} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>To-do List</h3>
                                    <p>Web development, design</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>

                <div className="works__right">
                    <Link to="/amazon-clone">
                        <div class="works__container">
                            <img src={image8} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>Amazon Clone</h3>
                                    <p>Web development, design</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                    <Link to="/weather-app">
                        <div class="works__container">
                            <img src={image9} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>Weather App</h3>
                                    <p>Web development, design, API</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                    <Link to="/makeup-artist-website">
                        <div class="works__container">
                            <img src={image10} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>Makeup Artist Website</h3>
                                    <p>Web development, design</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                    <Link to="/music-player">
                        <div class="works__container">
                            <img src={image11} class="works__image" />
                            <div class="works__overlay">
                                <div class="works__text">
                                    <h3>Music Player</h3>
                                    <p>Web development, design</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            <div className="works__footer">
                <p>&copy; 2021 Harshita Singh</p>
            </div>
        </div>
    )
}

export default Works
